import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import actions from './actions'

Vue.use(Vuex)

const state = {
  // 当前视口宽度
  ViewportWidth: window.innerWidth,
  // banner
  IndexInfo: null,
  // 多语言
  langList: [
    { key: 'zh', name: '简体中文' },
    { key: 'en', name: 'English' },
  ],
  // 菜单
  menuList: [
    { key: 'home' }, // 首页
    { key: 'intro',
      children: [
        { key: 'brief' },
        { key: 'organization' },
        { key: 'rule' },
      ]
    }, // 中心介绍
    { key: 'news' }, // 文化要闻
    { key: 'moments' }, // 中心动态
    { key: 'exchange' }, // 中心交流
    // { key: 'council',
    //   children: [
    //     { key: 'council_intro' },
    //     { key: 'council_demeanour' },
    // ] }, // 理事风采
    { key: 'council_demeanour' },
    { key: 'rostrum' }, // 名家讲坛
  ],
}

const mutations = {
  SET_VW: (state, info) => {
    state.ViewportWidth = info
  },
  SET_INDEX_INFO: (state, info) => {
    state.IndexInfo = info
  },
  SET_LANG: (state, info) => {
    state.lang = info
  },
}

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})

export default store
